import { v7 as uuidv7 } from "uuid";
import { FileWithPath } from "../files.types";

export const getFoldersFromFiles = (files: (File | FileWithPath)[]) => {
  const folders = new Set<string>();
  const folderObjects: {
    name: string;
    uuid: string;
    path: string;
    is_folder: boolean;
    parent_uuid: string | null;
  }[] = [];

  // First collect all unique folder paths
  files.forEach((file) => {
    let pathParts;
    if ("file" in file) {
      pathParts = file.path.split("/").slice(0, -1); // Remove filename
    } else {
      pathParts = file.webkitRelativePath.split("/").slice(0, -1); // Remove filename
    }
    let currentPath = "";

    pathParts.forEach((part) => {
      if (part) {
        currentPath = currentPath ? `${currentPath}/${part}` : part;
        folders.add(currentPath);
      }
    });
  });

  // Create folder objects for each unique path
  folders.forEach((path) => {
    const pathParts = path.split("/");
    const name = pathParts[pathParts.length - 1];
    folderObjects.push({
      name,
      uuid: uuidv7(),
      path,
      is_folder: true,
      parent_uuid: null, // Will be set below
    });
  });

  // Sort folders by path length to ensure parent folders are processed first
  folderObjects.sort((a, b) => a.path.length - b.path.length);

  // Set parent_uuid for each folder
  folderObjects.forEach((folder) => {
    const pathParts = folder.path.split("/");
    if (pathParts.length > 1) {
      // Remove the last part to get parent path
      const parentPath = pathParts.slice(0, -1).join("/");
      const parentFolder = folderObjects.find((f) => f.path === parentPath);
      if (parentFolder) {
        folder.parent_uuid = parentFolder.uuid;
      }
    }
  });

  return folderObjects;
};
